export function clearErrors(fieldNames = []) {
  return () => {
    _.forEach(fieldNames, (msg, field) => {
      this[`${field}`] = ''
    })

    if(typeof this.error !== 'undefined') {
      this.error = false
    }

    if(typeof this.message !== 'undefined') {
      this.message = ''
    }
  }
}

export default function(fields = []) {
  var fieldNames = {}
  fields.forEach(field => {
    fieldNames[`errors$${field}`] = ''
  })

  return {
    data() {
      return {
        ...fieldNames
      }
    },
    methods: {
      clearErrors: () => clearErrors(fieldNames),
      parseErrors: function(errors) {
        if(!errors) {
          return
        }

        _.forEach(errors, (value, key) => {
          var flatValue = _.isArray(value) ? value.join(' ') : value
          var [flatKey] = key.split('.')

          this[`errors$${flatKey}`] = flatValue
        })
      },
      validateEmail: function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
        return re.test(String(email).toLowerCase());
      },
    }
  }
}